export const SIGN_IN = "SIGN_IN";
export const SIGN_OUT = "SIGN_OUT";
export const FINISH_LOADING = "FINISH_LOADING";

export const OPEN_FILE_MODAL = "OPEN_FILE_MODAL";
export const CLOSE_FILE_MODAL = "CLOSE_FILE_MODAL";
export const OPEN_FOLDER_MODAL = "OPEN_FOLDER_MODAL";
export const CLOSE_FOLDER_MODAL = "CLOSE_FOLDER_MODAL";
export const SET_PATH_LOADING = "SET_PATH_LOADING";
export const SET_CURRENT_FILE = "SET_CURRENT_FILE";
export const RESET_CURRENT_FILE = "RESET_CURRENT_FILE";
export const UPDATE_CURRENT_FILE = "UPDATE_CURRENT_FILE";
export const SET_CURRENT_FOLDER = "SET_CURRENT_FOLDER";
export const SET_SUBFILES = "SET_SUBFILES";
export const SET_SUBFOLDERS = "SET_SUBFOLDERS";
export const SET_BEFORE_FOLDERS = "SET_BEFORE_FOLDERS";
export const SET_ROOT_FOLDER = "SET_ROOT_FOLDER";
